// Libs
import React from 'react';

// Components
import ToolbarPopupTool from '../../../toolbar/commonComponents/ToolbarPopupTool';
import MorePopup from './MoreToolPopup';

// Styles
import { MoreToolsSettings, ToolbarItemConfig } from '../../toolbarTypes';
import Icon from '../../../../components/icons/Icon';

const MoreTool = (props: { item: ToolbarItemConfig }): React.ReactElement => {
    const settings = props.item.toolSettings as MoreToolsSettings;

    return (
        <ToolbarPopupTool
            {...props}
            id={settings.popupId}
            popupId={settings.popupId}
            toolName="more"
            preventFocus
            name=""
            PopupComponent={MorePopup}
        >
            <Icon name="toolbar-more" />
        </ToolbarPopupTool>
    );
};

export default MoreTool;
